<script setup lang="ts">
import type { TCarouselProps } from '../model/common';

import { ProductCard } from '~/features/product-card';
import CarouselSlides from './CarouselSlides.vue';

import { useLastSeenProductsStore } from '~/features/store';
import { useFavorites } from '~/features/store/favorite';

const props = withDefaults(defineProps<TCarouselProps & { hidedIds?: string[] }>(), {
  hidedIds: () => [],
});

const { lastSeenProducts } = useLastSeenProductsStore();
const { handleFavoriteToggleCurried } = useFavorites();
const { buildAnalyticsParams } = await import('@/features/store/favorite/business/analyticsParams');
const handleFavoriteToggle = handleFavoriteToggleCurried('productCarousel');

const handleFavoriteToggleWithParams = async (product: any, index: number) => {
  const extraParams = await buildAnalyticsParams('сarousel', product, {
    index,
    moduleName: 'Просмотренные товары',
    moduleId: 'last-seen-slider',
    carouselPosition: 5,
    moduleSize: 'small',
  });

  await handleFavoriteToggle(product, extraParams);
};

const filteredProducts = computed(() => {
  if (props.hidedIds.length === 0) return lastSeenProducts.value;

  return lastSeenProducts.value.filter((it) => !props.hidedIds.includes(it.product.id));
});
</script>

<template>
  <CarouselSlides title="Просмотренные товары" :products="filteredProducts">
    <template #default="{ product, position }">
      <ProductCard
        :product="product"
        :addToCartFn="addToCartFn"
        :tracker-product-click="{
          enabled: trackerProductClick?.enabled,
          additionalPayload: { position, ...trackerProductClick?.additionalPayload },
        }"
        :tracker-product-view="{
          enabled: trackerProductView?.enabled,
          additionalPayload: { position, ...trackerProductView?.additionalPayload },
        }"
        @favorite-toggle="(p) => handleFavoriteToggleWithParams(p, position)"
      />
    </template>
  </CarouselSlides>
</template>
